export default {
    baseStyle: (props) => ({
        headingContainer: {
            gap: {base: 4},
            flexDirection: {base: 'column'},
            marginTop: {base: 6, lg: 8},
            marginBottom: {base: 12, lg: 16},
            px: {base: 2, lg: 0}
        },
        srpTitle: {
            textStyle: 'webH3'
        },
        srpSubtitle: {
            textStyle: 'bodySmRegular'
        },
        emptySearchCarouselTitle: {
            ...(props?.theme?.textStyles?.webH3 || {}),
            marginBottom: {base: 3, lg: 4}
        },
        lowResultsContainer: {
            px: {base: 2, lg: 0}
        }
    })
}
